module.exports = __webpack_public_path__ + "img/magento-setup-tuning_medium.7db993a3.webp";